export default __webpack_public_path__ + "static/media/lpilogocolor.26ad9e93.png";